import React, { useEffect } from 'react';
import { CheckCircle, X } from 'lucide-react';

const Notification = ({ message, onClose, isVisible }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); // Auto-close after 5 seconds
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-slide-up">
      <div className="glass-strong rounded-lg p-4 border border-toxic-green/30 shadow-2xl max-w-sm">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 glass rounded-full flex items-center justify-center flex-shrink-0 border border-toxic-green/50">
            <CheckCircle className="w-5 h-5 text-toxic-green" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-white/90 leading-relaxed">{message}</p>
          </div>
          <button
            onClick={onClose}
            className="p-1 text-white/60 hover:text-white transition-colors flex-shrink-0"
            aria-label="Fermer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Notification;

